(function() {
  class FilterHandler {
    constructor() {
      this.slider = document.querySelector('.collection__sidebar__slider');
      this.toggleButton = document.querySelector('.popout__toggle[aria-controls="filter-groups"]');
      this.overlay = document.querySelector('.slider-overlay-filter-mobile');
      this.justOpenedDrawer = false;

      this.setupEventListeners();
      this.observeDrawerState(); // ✅ NEW
    }

    setupEventListeners() {
      document.body.addEventListener("change", (event) => {
        if (event.target.classList.contains("filter-checkbox")) {
          this.checkFirstAvailabilityFilter();
          this.uncheckIfOnlyAvailabilityLeft();
        }
      });

      document.body.addEventListener("click", (event) => {
        if (this.justOpenedDrawer) return;

        const clickedCloseButton = event.target.closest('.close-btn');
        const clickedOverlay = this.overlay && event.target === this.overlay;

        if (clickedCloseButton || clickedOverlay) {
          this.closeFilter();
        }
      });

      // Detect when filter button opens the drawer
      if (this.toggleButton) {
        this.toggleButton.addEventListener("click", () => {
          setTimeout(() => {
            if (this.toggleButton.getAttribute("aria-expanded") === "true") {
              this.openOverlay();
              this.waitForDrawerAndRefreshRange();
            } else {
              this.closeOverlay();
            }
          }, 50);
        });
      }
    }

    openOverlay() {
      if (!this.overlay) return;

      this.justOpenedDrawer = true;

      this.overlay.classList.remove('filter-close');
      this.overlay.classList.add('filter-open');

      setTimeout(() => {
        this.justOpenedDrawer = false;
      }, 250);
    }

    closeOverlay() {
      if (!this.overlay) return;

      this.overlay.classList.remove('filter-open');
      this.overlay.classList.add('filter-close');
    }

    closeFilter() {
      if (this.slider) {
        this.slider.classList.remove('expanded');
        this.slider.classList.remove('expanding');
      }

      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-expanded', 'false');
      }

      this.closeOverlay();

      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
        bubbles: true
      }));
    }

    checkFirstAvailabilityFilter() {
      let availabilityFilters = document.querySelectorAll('.group-availability-extended .filter-checkbox');

      if (availabilityFilters.length > 0) {
        let firstFilter = availabilityFilters[0];

        if (!firstFilter.checked) {
          firstFilter.checked = true;
          firstFilter.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }

    uncheckIfOnlyAvailabilityLeft() {
      let allCheckedFilters = document.querySelectorAll('.filter-checkbox:checked');
      let availabilityCheckedFilters = document.querySelectorAll('.group-availability-extended .filter-checkbox:checked');

      if (allCheckedFilters.length === availabilityCheckedFilters.length && availabilityCheckedFilters.length === 1) {
        availabilityCheckedFilters[0].checked = false;
        availabilityCheckedFilters[0].dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    waitForDrawerAndRefreshRange() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.refreshRangeSlider();

          setTimeout(() => {
            this.refreshRangeSlider();
          }, 150);

          setTimeout(() => {
            this.refreshRangeSlider();
          }, 300);
        });
      });
    }

    refreshRangeSlider() {
      const rangeSlider = document.querySelector('[data-range-slider]');
      if (!rangeSlider || !this.isElementVisible(rangeSlider)) return;

      const leftDot = rangeSlider.querySelector('[data-range-left]');
      const rightDot = rangeSlider.querySelector('[data-range-right]');
      const line = rangeSlider.querySelector('[data-range-line]');

      if (!leftDot || !rightDot || !line) return;

      const min = parseFloat(rangeSlider.dataset.seMin);
      const max = parseFloat(rangeSlider.dataset.seMax);
      const minValue = parseFloat(rangeSlider.dataset.seMinValue);
      const maxValue = parseFloat(rangeSlider.dataset.seMaxValue);

      if ([min, max, minValue, maxValue].some(Number.isNaN)) return;
      if (max <= min) return;

      const sliderWidth = rangeSlider.offsetWidth;
      const handleWidth = rightDot.offsetWidth || leftDot.offsetWidth || 0;
      const usableWidth = Math.max(sliderWidth - handleWidth, 0);

      const leftRatio = (minValue - min) / (max - min);
      const rightRatio = (maxValue - min) / (max - min);

      const leftPos = Math.round(Math.max(0, Math.min(1, leftRatio)) * usableWidth);
      const rightPos = Math.round(Math.max(0, Math.min(1, rightRatio)) * usableWidth);

      leftDot.style.left = `${leftPos}px`;
      rightDot.style.left = `${rightPos}px`;

      line.style.marginLeft = `${leftPos}px`;
      line.style.width = `${Math.max(rightPos - leftPos, 0)}px`;
    }

    isElementVisible(element) {
      return !!(
        element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length
      );
    }

    // ✅ NEW: Observe drawer state instead of product updates
    observeDrawerState() {
      if (!this.slider) return;

      const observer = new MutationObserver(() => {
        if (!this.slider.classList.contains('expanded')) {
          this.closeOverlay();
        }
      });

      observer.observe(this.slider, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  new FilterHandler();
})();